// События аналитики сайта → GA4 (см. analytics.ts). Персональные данные сюда не передавать.
import { trackEvent } from './analytics';

type EventName = 'route_cta_click' | 'team_building_contact_click' | 'have_access_click';

export function track(event: EventName, params: Record<string, string>): void {
  trackEvent(event, params);
}
